import React from "react";
import {useRouteTemplates} from "hooks/useRouteTemplates";
import {useSetting} from "../../contexts/setting";
import cn from "classnames";
import TemplateControls from "../../layout/TemplateControls";
import HighlightShortcuts from "../../layout/HighlightShortcuts";

const Video = () => {
  const {visible, currentVideoPopup} = useSetting();
  // Without the banners an admin removed (libs/bannerComposition.ts).
  const items = useRouteTemplates("video");
  const bannerIds = items.map((template) => template.id);
  const hasOnlyOneBanner = bannerIds.length === 1;

  return (
    <div>
      <HighlightShortcuts />
      {items.map((item) => (
        <div
          key={item.id}
          className={cn("template-wrap", {
            hidden: !hasOnlyOneBanner && !visible.some((x) => x === item.id),
            popup: currentVideoPopup === item.id,
          })}
        >
          <div className="template-annotation">
            <span
              className="label"
              data-tooltip={item.tooltip || null}
            >{`${item.label} (${item.dimensions}${item.suffix || ""})`}</span>
            <TemplateControls
              id={item.id}
              templateChannel="video"
              hasOnlyOneBanner={hasOnlyOneBanner}
              bannerIds={bannerIds}
            />
          </div>
          {item.getComponent()}
        </div>
      ))}
    </div>
  );
};

export default Video;
